import { styled } from 'styled-components'
import media from 'common-ui-components/src/vtj/theme/media'
import {
  responsiveMaxWidth,
  responsivePadding,
} from 'common-ui-components/src/vtj/theme/helpers'
import { Block, ExternalLink, ExternalLinkProps } from 'suomifi-ui-components'

export const FooterContainer = styled.footer``

export const InnerFooterContainer = styled.div`
  display: flex;
  justify-content: center;
  background: ${(props) => props.theme.colors.brandBase};

  ${media.mobileAndTablet} {
    flex-direction: column;
  }
`

export const ColorBar = styled.div`
  display: flex;
  width: 100%;
  height: 10px;

  ${media.mobileAndTablet} {
    height: 7px;
  }

  &:before {
    content: '';
    display: inline-block;
    background-color: #69d8d7;
    width: 70%;
  }
  &:after {
    content: '';
    display: inline-block;
    background-color: #e30450;
    width: 30%;
  }
`

export const FooterRow = styled(Block)`
  ${responsivePadding()};
  ${responsiveMaxWidth()};
  padding-top: ${(props) => props.theme.spacing.xl};
  padding-bottom: ${(props) => props.theme.spacing.xl};
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: flex-start;
  gap: ${(props) => props.theme.spacing.xxl};

  ${media.mobileAndTablet} {
    flex-direction: column;
    gap: 0;
  }
`

export const DvvLogo = styled.img`
  width: 200px;
  ${media.mobileAndTablet} {
    width: 160px;
  }
`

export const VerticalRuleDesktop = styled.div`
  border-left: 1px solid ${(props) => props.theme.colors.whiteBase};
  align-self: stretch;

  ${media.mobileAndTablet} {
    display: none;
  }
`

export const StyledExternalLink = styled(ExternalLink)<ExternalLinkProps>`
  color: ${(props) => props.theme.colors.whiteBase} !important;
  &:visited {
    color: ${(props) => props.theme.colors.whiteBase} !important;
  }
`
